import type { ISPD } from '../../../sprites/sprites'
import { sprites } from '../../../sprites/sprites-sidecar'
import { EVoyageMissionType } from '../missions/voyageMissionData'

export interface IVoyageLocation {
  mission: EVoyageMissionType
  frames: ISPD[]
  dangerLevel: number
  text: string
}

export function create(d: Partial<IVoyageLocation>): IVoyageLocation {
  const _default: IVoyageLocation = {
    mission: EVoyageMissionType.Null,
    frames: sprites.voyStarmapInvalid,
    dangerLevel: 0,
    text: 'Unknown',
  }
  return Object.assign({}, _default, d)
}

export function createMultiple(
  num: number,
  d: Partial<IVoyageLocation>,
): IVoyageLocation[] {
  let locs: IVoyageLocation[] = []
  for (let i = 0; i < num; i++) {
    locs.push(create(d))
  }
  return locs
}

export function generateStandardLocations() {
  let locs: IVoyageLocation[] = []

  for (let i = 0; i < 5; i++) {
    locs.push(
      create({
        text: 'Starbase-' + i,
        mission: EVoyageMissionType.Starbase,
        dangerLevel: 0,
        frames: sprites.voyStarmapStarbase,
      }),
    )
  }

  locs.push(
    ...createMultiple(3, {
      text: 'Enemy territory',
      mission: EVoyageMissionType.CombatZone1,
      dangerLevel: 1,
      frames: sprites.voyStarmapAlienTerritory,
    }),
  )

  locs.push(
    ...createMultiple(3, {
      text: 'Hammerhead',
      mission: EVoyageMissionType.FightAlienShip2,
      dangerLevel: 2,
      frames: sprites.voyStarmapAlienShip,
    }),
  )

  locs.push(
    ...createMultiple(3, {
      text: 'Aliens 1',
      mission: EVoyageMissionType.FightAliens1,
      dangerLevel: 1,
      frames: sprites.voyStarmapAliens,
    }),
  )

  locs.push(
    ...createMultiple(3, {
      text: 'Aliens 2',
      mission: EVoyageMissionType.FightAliens2,
      dangerLevel: 2,
      frames: sprites.voyStarmapAliens,
    }),
  )

  locs.push(
    ...createMultiple(3, {
      text: 'Aliens 3',
      mission: EVoyageMissionType.FightAlienShip3,
      dangerLevel: 3,
      frames: sprites.voyStarmapAliens,
    }),
  )

  return locs
}
